export default "__VITE_ASSET__CVimCgxh__"